import React, { useEffect, useState } from 'react';
import { HeroSection, ProblemSection, FailedApproaches } from '../components/Sections1';
import { UniqueMechanism, WhatYouGet, WhoIsFor } from '../components/Sections2';
import { HowItWorks, ProofSection, FAQSection, FinalOffer } from '../components/Sections3';
import { SectionDivider, CTAButton } from '../components/Shared';
import { PurchaseBanner } from '../components/PurchaseBanner';
import { initMetaPixel } from '../utils/metaPixel';
import { AnimatePresence, motion } from 'framer-motion';
export const LandingPage = () => {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-dark text-white font-inter selection:bg-gold selection:text-dark" data-id="element-138">
      {/* Social Proof Top Banner */}
      <motion.div animate={{
      backgroundColor: ['#d4af37', '#b8962e', '#e8c84a', '#d4af37']
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="w-full text-dark py-2.5 px-4 text-center" data-id="element-139">
        <motion.p animate={{
        scale: [1, 1.02, 1]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="font-inter text-xs md:text-sm font-bold tracking-wide flex items-center justify-center gap-3" data-id="element-140">
          <motion.span animate={{
          rotate: [0, -10, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-xl md:text-2xl inline-block" data-id="element-141">
            🏆
          </motion.span>
          <span data-id="element-142">#1 EN VENTAS</span>
          <span className="text-dark/60" data-id="element-143">·</span>
          <span className="font-medium" data-id="element-144">Categoría Relaciones EE.UU.</span>
          <span className="text-dark/60" data-id="element-145">·</span>
          <span className="font-medium" data-id="element-146">Abril 2026</span>
          <motion.span animate={{
          rotate: [0, 10, -10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-xl md:text-2xl inline-block" data-id="element-147">
            🏆
          </motion.span>
        </motion.p>
      </motion.div>

      <main data-id="element-148">
        <HeroSection data-id="element-149" />
        <SectionDivider data-id="element-150" />
        <ProblemSection data-id="element-151" />
        <FailedApproaches data-id="element-152" />
        <UniqueMechanism data-id="element-153" />
        <WhatYouGet data-id="element-154" />
        <WhoIsFor data-id="element-155" />
        <SectionDivider data-id="element-156" />
        <HowItWorks data-id="element-157" />
        <ProofSection data-id="element-158" />
        <FAQSection data-id="element-159" />
        <FinalOffer data-id="element-160" />
      </main>

      <footer className="py-5 md:py-8 pb-20 md:pb-8 text-center border-t border-dark-border bg-black" data-id="element-161">
        <p className="font-inter text-gray-500 text-sm" data-id="element-162">
          © {new Date().getFullYear()} El Método Acento Prohibido. Todos los
          derechos reservados.
        </p>
      </footer>

      <PurchaseBanner data-id="element-163" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-164">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-3 bg-black/90 backdrop-blur-md border-t border-gold/20 z-50 md:hidden" data-id="element-165">
            <CTAButton scrollToOffer className="w-full py-3 text-base shadow-lg shadow-gold/20" data-id="element-166" />
          </motion.div>}
      </AnimatePresence>
    </div>;
};